import { render, staticRenderFns } from "./ImageSelection.vue?vue&type=template&id=54afde28&scoped=true"
import script from "./ImageSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageSelection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ImageSelection.vue?vue&type=style&index=0&id=54afde28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afde28",
  null
  
)

export default component.exports